<template>
  <div class="breadcrumb">
    <!-- 面包屑导航 -->
    <a-breadcrumb v-if="$route.meta.breadcrumb !== false">

      <a-breadcrumb-item>
        <v-icon icon="AppstoreOutlined"/>
      </a-breadcrumb-item>

      <template v-for="i of routes" :key="i.path">
        <a-breadcrumb-item>
          <router-link :to="i.path">{{ i.meta.name }}</router-link>
        </a-breadcrumb-item>
      </template>

    </a-breadcrumb>
  </div>

</template>

<script setup>
/**/

/*当前路由*/
import {computed} from "vue";
import {useRouter} from "vue-router";

/* 路由对象 */
const router = useRouter();

/* 获取路由项 */
const routes = computed(() => {
  /* eslint-disable-next-line */
  return router.currentRoute.value.matched.filter((route) => {
    return !!route.meta.name && route.path !== "/";
  });
});


</script>

<style scoped lang="scss">
.breadcrumb {
  @include flex-center;
  align-items: center;
  padding-left: 20px;
  border-bottom: 1px solid transparent;
  //border-left: 1px solid #e5e6eb;
  width: 100%;
  height: 100%;

  :deep(.ant-breadcrumb-separator), a {
    color: $admin-header-color !important;
  }
}
</style>